import { Box, Container, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormattedOwnerData } from "../../../core/models/ownerData/ownerData.model";
import "./ServicesHeader.scss";
import { useState } from "react";
import { TabsDataManagementHeader } from "../../../core/models/managements/managements.model";
import theme from "../../../muiTheme";

interface ManagementsHeaderProps {
  ownerData: FormattedOwnerData | null;
  isDesktopViewport: boolean;
  changeTab: Function;
}

const ServicesHeader = ({
  ownerData,
  isDesktopViewport,
  changeTab,
}: ManagementsHeaderProps) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<string>("managements");

  const tabsDataManagementHeader: TabsDataManagementHeader[] = [
    {
      id: "managements",
      value: "managements",
      label: "Header.Nav.Servicios",
    },
    {
      id: "historic",
      value: "historic",
      label: "Gestiones.Header.Historico",
    },
  ];

  return (
    <Box className="management">
    <Stack
      direction="column"
      component="article"
      className="management__header"
    >
      <Container component="div">
        <Typography variant="h1" component="h1">
          {t("Header.Nav.Servicios")}
        </Typography>
        <Box sx={{ width: "100%" }}>
          <Tabs
          className="tabs-wrapper"
            value={selectedTab}
            onChange={(event: React.SyntheticEvent, newValue: string) => {
              setSelectedTab(newValue);
              changeTab(newValue);
            }}
            component={"ul"}
            sx={{
              ".MuiTabs-indicator": {
                left: 0,
              },
              paddingLeft: 0,
            }}
          >
            {tabsDataManagementHeader.map(({ id, label, value }) => (
              <Tab
                key={id}
                component="a"
                label={
                  <Typography component="span" variant="tab">
                    {t(label)}
                  </Typography>
                }
                sx={{ color: theme.palette.grey[500] }}
                value={value}
                className="tab"
                disableRipple
              />
            ))}
          </Tabs>
        </Box>
      </Container>
    </Stack>
  </Box>
  );
};

export default ServicesHeader;
